// @generated by protoc-gen-es v1.4.1 with parameter "target=ts+js+dts,import_extension=.mjs"
// @generated from file mysale/api/model.proto (package nautilus.mysale.model.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from enum nautilus.mysale.model.v1.WorkingStatus
 */
export const WorkingStatus = proto3.makeEnum(
  "nautilus.mysale.model.v1.WorkingStatus",
  [
    {no: 0, name: "WORKING_STATUS_OFFLINE", localName: "OFFLINE"},
    {no: 1, name: "WORKING_STATUS_ACCEPT", localName: "ACCEPT"},
    {no: 2, name: "WORKING_STATUS_NOT_ACCEPT", localName: "NOT_ACCEPT"},
  ],
);

/**
 * @generated from enum nautilus.mysale.model.v1.CRMTitle
 */
export const CRMTitle = proto3.makeEnum(
  "nautilus.mysale.model.v1.CRMTitle",
  [
    {no: 0, name: "CRM_TITLE_UNSPECIFIED"},
    {no: 1, name: "CRM_TITLE_MANAGER"},
    {no: 2, name: "CRM_TITLE_STAFF"},
    {no: 3, name: "CRM_TITLE_LEADER"},
    {no: 4, name: "CRM_TITLE_HELPDESK"},
  ],
);

/**
 * @generated from enum nautilus.mysale.model.v1.ListPlayerType
 */
export const ListPlayerType = proto3.makeEnum(
  "nautilus.mysale.model.v1.ListPlayerType",
  [
    {no: 0, name: "LIST_PLAYER_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "LIST_PLAYER_TYPE_NEW", localName: "NEW"},
    {no: 2, name: "LIST_PLAYER_TYPE_RWB", localName: "RWB"},
    {no: 3, name: "LIST_PLAYER_TYPE_NWB", localName: "NWB"},
    {no: 4, name: "LIST_PLAYER_TYPE_ALL_INACTIVE", localName: "ALL_INACTIVE"},
    {no: 5, name: "LIST_PLAYER_TYPE_ALL_ACTIVE", localName: "ALL_ACTIVE"},
  ],
);

/**
 * @generated from enum nautilus.mysale.model.v1.PlayerDeposit
 */
export const PlayerDeposit = proto3.makeEnum(
  "nautilus.mysale.model.v1.PlayerDeposit",
  [
    {no: 0, name: "PLAYER_DEPOSIT_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PLAYER_DEPOSIT_NO", localName: "NO"},
    {no: 2, name: "PLAYER_DEPOSIT_YES", localName: "YES"},
  ],
);

/**
 * @generated from enum nautilus.mysale.model.v1.AssignStatus
 */
export const AssignStatus = proto3.makeEnum(
  "nautilus.mysale.model.v1.AssignStatus",
  [
    {no: 0, name: "ASSIGN_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ASSIGN_STATUS_NO", localName: "NO"},
    {no: 2, name: "ASSIGN_STATUS_YES", localName: "YES"},
  ],
);

/**
 * @generated from enum nautilus.mysale.model.v1.PlayerCallStatus
 */
export const PlayerCallStatus = proto3.makeEnum(
  "nautilus.mysale.model.v1.PlayerCallStatus",
  [
    {no: 0, name: "PLAYER_CALL_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PLAYER_CALL_STATUS_NO", localName: "NO"},
    {no: 2, name: "PLAYER_CALL_STATUS_YES", localName: "YES"},
  ],
);

/**
 * @generated from enum nautilus.mysale.model.v1.PhoneFilter
 */
export const PhoneFilter = proto3.makeEnum(
  "nautilus.mysale.model.v1.PhoneFilter",
  [
    {no: 0, name: "PHONE_FILTER_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PHONE_FILTER_NO", localName: "NO"},
    {no: 2, name: "PHONE_FILTER_YES", localName: "YES"},
  ],
);

/**
 * @generated from enum nautilus.mysale.model.v1.Status
 */
export const Status = proto3.makeEnum(
  "nautilus.mysale.model.v1.Status",
  [
    {no: 0, name: "UNSPECIFIED"},
    {no: 1, name: "INACTIVE"},
    {no: 2, name: "ACTIVE"},
    {no: 3, name: "LOCKED"},
    {no: 4, name: "BANNED"},
    {no: 5, name: "INCOMPLETE"},
  ],
);

/**
 * @generated from enum nautilus.mysale.model.v1.PlayerSortField
 */
export const PlayerSortField = proto3.makeEnum(
  "nautilus.mysale.model.v1.PlayerSortField",
  [
    {no: 0, name: "PLAYER_SORT_FIELD_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PLAYER_SORT_FIELD_PLAYER_ID", localName: "PLAYER_ID"},
    {no: 2, name: "PLAYER_SORT_FIELD_CREATED_AT", localName: "CREATED_AT"},
    {no: 3, name: "PLAYER_SORT_FIELD_LAST_BET_DATE", localName: "LAST_BET_DATE"},
    {no: 4, name: "PLAYER_SORT_FIELD_LAST_BET_AMOUNT", localName: "LAST_BET_AMOUNT"},
    {no: 5, name: "PLAYER_SORT_FIELD_FIRST_DEPOSIT_DATE", localName: "FIRST_DEPOSIT_DATE"},
    {no: 6, name: "PLAYER_SORT_FIELD_LAST_DEPOSIT_DATE", localName: "LAST_DEPOSIT_DATE"},
  ],
);

/**
 * @generated from enum nautilus.mysale.model.v1.SortOrder
 */
export const SortOrder = proto3.makeEnum(
  "nautilus.mysale.model.v1.SortOrder",
  [
    {no: 0, name: "SORT_ORDER_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SORT_ORDER_ASC", localName: "ASC"},
    {no: 2, name: "SORT_ORDER_DESC", localName: "DESC"},
  ],
);

/**
 * @generated from enum nautilus.mysale.model.v1.AccountStatus
 */
export const AccountStatus = proto3.makeEnum(
  "nautilus.mysale.model.v1.AccountStatus",
  [
    {no: 0, name: "ACCOUNT_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ACCOUNT_STATUS_INACTIVE", localName: "INACTIVE"},
    {no: 2, name: "ACCOUNT_STATUS_ACTIVE", localName: "ACTIVE"},
    {no: 3, name: "ACCOUNT_STATUS_LOCKED", localName: "LOCKED"},
    {no: 4, name: "ACCOUNT_STATUS_BANNED", localName: "BANNED"},
    {no: 5, name: "ACCOUNT_STATUS_INCOMPLETE", localName: "INCOMPLETE"},
  ],
);

/**
 * @generated from enum nautilus.mysale.model.v1.VerifyType
 */
export const VerifyType = proto3.makeEnum(
  "nautilus.mysale.model.v1.VerifyType",
  [
    {no: 0, name: "VERIFY_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "VERIFY_TYPE_EMAIL", localName: "EMAIL"},
    {no: 2, name: "VERIFY_TYPE_SMS", localName: "SMS"},
    {no: 3, name: "VERIFY_TYPE_VOICE", localName: "VOICE"},
  ],
);

/**
 * @generated from enum nautilus.mysale.model.v1.CallStatus
 */
export const CallStatus = proto3.makeEnum(
  "nautilus.mysale.model.v1.CallStatus",
  [
    {no: 0, name: "CALL_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CALL_STATUS_ANSWERED", localName: "ANSWERED"},
    {no: 2, name: "CALL_STATUS_NO_RESPONSE", localName: "NO_RESPONSE"},
    {no: 3, name: "CALL_STATUS_NO_PICK_UP", localName: "NO_PICK_UP"},
  ],
);

/**
 * @generated from enum nautilus.mysale.model.v1.DomainStatus
 */
export const DomainStatus = proto3.makeEnum(
  "nautilus.mysale.model.v1.DomainStatus",
  [
    {no: 0, name: "DOMAIN_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "DOMAIN_STATUS_INITIALIZING", localName: "INITIALIZING"},
    {no: 2, name: "DOMAIN_STATUS_VERIFYING", localName: "VERIFYING"},
    {no: 3, name: "DOMAIN_STATUS_ACTIVE", localName: "ACTIVE"},
    {no: 4, name: "DOMAIN_STATUS_FAILED", localName: "FAILED"},
  ],
);

/**
 * @generated from message nautilus.mysale.model.v1.PlayerFilter
 */
export const PlayerFilter = proto3.makeMessageType(
  "nautilus.mysale.model.v1.PlayerFilter",
  () => [
    { no: 1, name: "cs_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "full_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "player_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "status", kind: "enum", T: proto3.getEnumType(Status) },
    { no: 9, name: "deposit", kind: "enum", T: proto3.getEnumType(PlayerDeposit) },
    { no: 10, name: "label_ids", kind: "scalar", T: 3 /* ScalarType.INT64 */, repeated: true },
    { no: 11, name: "assign_status", kind: "enum", T: proto3.getEnumType(AssignStatus) },
    { no: 12, name: "phone_number", kind: "message", T: PhoneNumber },
    { no: 13, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "phone_filter", kind: "enum", T: proto3.getEnumType(PhoneFilter) },
    { no: 15, name: "call_status", kind: "enum", T: proto3.getEnumType(PlayerCallStatus) },
    { no: 16, name: "affiliate_ids", kind: "scalar", T: 3 /* ScalarType.INT64 */, repeated: true },
    { no: 17, name: "campaign_ids", kind: "scalar", T: 3 /* ScalarType.INT64 */, repeated: true },
  ],
);

/**
 * @generated from message nautilus.mysale.model.v1.Player
 */
export const Player = proto3.makeMessageType(
  "nautilus.mysale.model.v1.Player",
  () => [
    { no: 1, name: "player_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "full_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "phone_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "created_at", kind: "message", T: Timestamp },
    { no: 11, name: "telegram_user_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 12, name: "telegram_phone_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "utm_source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "referrer_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 16, name: "referral_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 17, name: "metadata", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "first_deposit_payment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 19, name: "first_deposit_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 20, name: "first_deposit_currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "first_deposit_at", kind: "message", T: Timestamp },
    { no: 32, name: "first_deposit_system_currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 33, name: "first_deposit_system_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 22, name: "last_deposit_payment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 23, name: "last_deposit_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 24, name: "last_deposit_currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 25, name: "last_deposit_at", kind: "message", T: Timestamp },
    { no: 34, name: "last_deposit_system_currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 35, name: "last_deposit_system_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 26, name: "last_bet_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 27, name: "last_bet_currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 28, name: "last_bet_game_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 29, name: "last_bet_at", kind: "message", T: Timestamp },
    { no: 30, name: "cs_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 31, name: "datas", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: PlayerData} },
    { no: 36, name: "kyc_status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 37, name: "first_withdraw_payment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 38, name: "first_withdraw_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 39, name: "first_withdraw_currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 40, name: "first_withdraw_at", kind: "message", T: Timestamp },
    { no: 41, name: "first_withdraw_system_currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 42, name: "first_withdraw_system_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 43, name: "last_withdraw_payment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 44, name: "last_withdraw_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 45, name: "last_withdraw_currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 46, name: "last_withdraw_at", kind: "message", T: Timestamp },
    { no: 47, name: "last_withdraw_system_currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 48, name: "last_withdraw_system_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 49, name: "total_bet_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 50, name: "total_deposit_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 51, name: "total_withdraw_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 52, name: "domain_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 53, name: "last_sign_in", kind: "message", T: Timestamp },
    { no: 54, name: "affiliate_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 55, name: "campaign_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 56, name: "campaign_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 57, name: "contact", kind: "message", T: PlayerContact },
    { no: 58, name: "phone_number_detail", kind: "message", T: PhoneNumber },
    { no: 60, name: "labels", kind: "message", T: Label, repeated: true },
  ],
);

/**
 * @generated from message nautilus.mysale.model.v1.Label
 */
export const Label = proto3.makeMessageType(
  "nautilus.mysale.model.v1.Label",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message nautilus.mysale.model.v1.PlayerData
 */
export const PlayerData = proto3.makeMessageType(
  "nautilus.mysale.model.v1.PlayerData",
  () => [
    { no: 1, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "total_deposit", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "total_withdraw", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "cash_balance", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "bonus_balance", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "free_remaining_spins", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "total_bet", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "total_win", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "total_jp_contribution", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 10, name: "total_jp_win", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 11, name: "total_refund", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 12, name: "total_fee", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 13, name: "player_ggr", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 14, name: "company_ggr", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 15, name: "cashback_amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: "rebate_amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 17, name: "withdrawable_balance", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 18, name: "non_withdrawable_balance", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 19, name: "lucky_spin_bonus", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 20, name: "lucky_spin_cash", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 21, name: "lucky_spin_motorbike", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 22, name: "lucky_spin_gold", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 23, name: "lucky_spin_phone", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message nautilus.mysale.model.v1.PhoneNumber
 */
export const PhoneNumber = proto3.makeMessageType(
  "nautilus.mysale.model.v1.PhoneNumber",
  () => [
    { no: 1, name: "country_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "national_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message nautilus.mysale.model.v1.SaleCs
 */
export const SaleCs = proto3.makeMessageType(
  "nautilus.mysale.model.v1.SaleCs",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "metadata", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "role_ids", kind: "scalar", T: 3 /* ScalarType.INT64 */, repeated: true },
    { no: 7, name: "status", kind: "enum", T: proto3.getEnumType(AccountStatus) },
    { no: 8, name: "work_phone_number", kind: "message", T: PhoneNumber },
    { no: 9, name: "verify_type", kind: "enum", T: proto3.getEnumType(VerifyType) },
    { no: 10, name: "create_at", kind: "message", T: Timestamp },
    { no: 11, name: "titles", kind: "enum", T: proto3.getEnumType(CRMTitle), repeated: true },
    { no: 12, name: "full_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "department", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "team", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "nick_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "personal_phone_number", kind: "message", T: PhoneNumber },
    { no: 18, name: "telegram_username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "onbuka_username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "contract", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "working_status", kind: "enum", T: proto3.getEnumType(WorkingStatus) },
    { no: 24, name: "avatar", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 25, name: "affiliate_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 26, name: "affiliate_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 27, name: "parent_affiliate_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message nautilus.mysale.model.v1.SaleCsChange
 */
export const SaleCsChange = proto3.makeMessageType(
  "nautilus.mysale.model.v1.SaleCsChange",
  () => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "field" },
    { no: 2, name: "metadata", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "field" },
    { no: 3, name: "verify_type", kind: "enum", T: proto3.getEnumType(VerifyType), oneof: "field" },
    { no: 4, name: "roles", kind: "message", T: SaleCsChange_OperatorRoles, oneof: "field" },
    { no: 5, name: "work_phone_number", kind: "message", T: PhoneNumber, oneof: "field" },
    { no: 6, name: "personal_phone_number", kind: "message", T: PhoneNumber, oneof: "field" },
    { no: 7, name: "department", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "field" },
    { no: 8, name: "team", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "field" },
    { no: 9, name: "nick_name", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "field" },
    { no: 10, name: "telegram_username", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "field" },
    { no: 11, name: "onbuka_username", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "field" },
    { no: 12, name: "contract", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "field" },
    { no: 14, name: "avatar", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "field" },
    { no: 16, name: "affiliate", kind: "message", T: SaleCsChange_Affiliate, oneof: "field" },
    { no: 17, name: "full_name", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "field" },
  ],
);

/**
 * @generated from message nautilus.mysale.model.v1.SaleCsChange.OperatorRoles
 */
export const SaleCsChange_OperatorRoles = proto3.makeMessageType(
  "nautilus.mysale.model.v1.SaleCsChange.OperatorRoles",
  () => [
    { no: 1, name: "role_ids", kind: "scalar", T: 3 /* ScalarType.INT64 */, repeated: true },
  ],
  {localName: "SaleCsChange_OperatorRoles"},
);

/**
 * @generated from message nautilus.mysale.model.v1.SaleCsChange.Affiliate
 */
export const SaleCsChange_Affiliate = proto3.makeMessageType(
  "nautilus.mysale.model.v1.SaleCsChange.Affiliate",
  () => [
    { no: 1, name: "changes", kind: "message", T: SaleCsChange_Affiliate_AffiliateChange, repeated: true },
  ],
  {localName: "SaleCsChange_Affiliate"},
);

/**
 * @generated from message nautilus.mysale.model.v1.SaleCsChange.Affiliate.AffiliateChange
 */
export const SaleCsChange_Affiliate_AffiliateChange = proto3.makeMessageType(
  "nautilus.mysale.model.v1.SaleCsChange.Affiliate.AffiliateChange",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "field" },
    { no: 2, name: "parent_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, oneof: "field" },
  ],
  {localName: "SaleCsChange_Affiliate_AffiliateChange"},
);

/**
 * @generated from message nautilus.mysale.model.v1.SaleCsFilter
 */
export const SaleCsFilter = proto3.makeMessageType(
  "nautilus.mysale.model.v1.SaleCsFilter",
  () => [
    { no: 1, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "cs_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "ids", kind: "scalar", T: 3 /* ScalarType.INT64 */, repeated: true },
    { no: 5, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "domain_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "affiliate_ids", kind: "scalar", T: 3 /* ScalarType.INT64 */, repeated: true },
  ],
);

/**
 * @generated from message nautilus.mysale.model.v1.Domain
 */
export const Domain = proto3.makeMessageType(
  "nautilus.mysale.model.v1.Domain",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "domain", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "nameservers", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "status", kind: "enum", T: proto3.getEnumType(DomainStatus) },
  ],
);

/**
 * @generated from message nautilus.mysale.model.v1.StaffRole
 */
export const StaffRole = proto3.makeMessageType(
  "nautilus.mysale.model.v1.StaffRole",
  () => [
    { no: 1, name: "role_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message nautilus.mysale.model.v1.Note
 */
export const Note = proto3.makeMessageType(
  "nautilus.mysale.model.v1.Note",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "note", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "cs_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "player_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "created_at", kind: "message", T: Timestamp },
    { no: 6, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message nautilus.mysale.model.v1.PlayerContact
 */
export const PlayerContact = proto3.makeMessageType(
  "nautilus.mysale.model.v1.PlayerContact",
  () => [
    { no: 1, name: "phone_number", kind: "message", T: PhoneNumber },
    { no: 2, name: "telegram_phone_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "telegram_username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message nautilus.mysale.model.v1.CallReport
 */
export const CallReport = proto3.makeMessageType(
  "nautilus.mysale.model.v1.CallReport",
  () => [
    { no: 1, name: "staff_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "staff_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "total_players", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "total_calls", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "total_answer", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "total_no_resposne", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "total_no_pickup", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "total_internet_number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "total_fake_number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

